import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, endpoints } from "@/lib/api";

// Admin-editable site settings (logo, contact, socials, media) with safe defaults.
export const SITE_DEFAULTS = {
  org_name: "Citizen Awareness Foundation",
  tagline: "Aware • Responsible • Together",
  logo_url: "",
  hero_headline: "Awareness Creates",
  hero_highlight: "Change",
  hero_sub: "Together we educate, empower and inspire communities through awareness, service and responsible civic action — across India.",
  contact_email: "citizenawarenessfoundation@cafvoice.org",
  contact_phone: "+91 90000 00000",
  address: "4th Floor, Civic Trust Tower, MG Road, Bengaluru 560001",
  footer_about: "Citizen Awareness Foundation is a non-partisan Indian non-profit (Section 8 company, incorporated 2026) driving awareness, transparency, and civic action — through peaceful, lawful, fact-based campaigns.",
  registered_line: "Section 8 Company — 12A • 80G • CSR-1. Donations eligible for tax deduction.",
  facebook_url: "https://facebook.com",
  twitter_url: "https://twitter.com",
  instagram_url: "https://instagram.com",
  linkedin_url: "https://linkedin.com",
  youtube_url: "https://youtube.com",
  whatsapp_url: "https://wa.me/919000000000",
  telegram_url: "https://t.me/caf_official",
  video_embed_url: "https://www.youtube.com/embed/dQw4w9WgXcQ",
  video_poster_url: "https://images.unsplash.com/photo-1497486751825-1233686d5d80?w=1600&q=80",
  video_caption: "CAF Founding Reel 2026 • 1:30",
  hero_image_1: "https://images.unsplash.com/photo-1593113598332-cd288d649433?w=900&q=80",
  hero_image_2: "https://images.unsplash.com/photo-1594708767771-a7502209ff51?w=600&q=80",
  hero_image_3: "https://images.unsplash.com/photo-1497486751825-1233686d5d80?w=600&q=80",
  donate_image_url: "https://images.unsplash.com/photo-1559027615-cd4628902d4a?w=900&q=80",
  impact_image_url: "https://images.unsplash.com/photo-1524069290683-0457abfe42c3?w=1600&q=80",
  impact_title: "From one classroom in Lucknow to 18+ villages across India.",
  impact_sub: "Every number above has a face, a name and a story behind it.",
  impact_callout_1: "25 schools getting clean water",
  impact_callout_2: "1,000 scholarships by end of 2026",
  impact_callout_3: "6 states • growing every month",
};

const SiteContext = createContext({ ...SITE_DEFAULTS, refreshSite: () => {} });

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(SITE_DEFAULTS);

  const refreshSite = useCallback(() => {
    api.get(endpoints.siteSettings)
      .then((s) => setSite({ ...SITE_DEFAULTS, ...s }))
      .catch(() => {});
  }, []);

  useEffect(() => { refreshSite(); }, [refreshSite]);

  return <SiteContext.Provider value={{ ...site, refreshSite }}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
